import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Radio, Stack, Typography } from '@mui/material';
import ActionButton from 'common/components/ActionButton';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import YesNoDialog from 'common/components/YesNoDialog';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'suneditor/dist/css/suneditor.min.css';
import MyAvailabilityDetails from './MyAvailabilityDetails';

const MyAvailabilityCard = ({ selected, availability, onDelete, onEdit, onSelect }) => {
    const { t } = useTranslation();

    const [openConfirmDeleteDlg, setOpenConfirmDeleteDlg] = useState(false);
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();
    const [expanded, setExpanded] = useState(null);

    const titleDlg = t('myAvailability.myAvailabilityItem.deleteConfirm');
    const messageDlg = t('myAvailability.myAvailabilityItem.deleteMessage');

    const toggle = (id) => setExpanded((prev) => (prev === id ? null : id));

    const handleDelete = (e) => {
        e.stopPropagation();
        setOpenConfirmDeleteDlg(true);
    };

    const confirmDelete = () => {
        onDelete(availability);
        setOpenConfirmDeleteDlg(false);
    };

    const cancelDlg = () => {
        setOpenConfirmDeleteDlg(false);
    };

    return (
        <Fragment>
            <Stack
                direction="column"
                spacing={1}
                className={cx(flexBox.overflowHidden, onlive.borderMediumGray, flexBox.borderRadius2)}
            >
                <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                    className={flexBox.padding1}
                >
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Radio
                            color={'primary'}
                            checked={availability.id === selected?.id}
                            onChange={() => onSelect(availability)}
                            // value={availability.id}
                            name="radio-buttons"
                        />
                        <Typography variant="onliveH6" fontWeight={500}>
                            {availability.name}
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                        {onEdit ? (
                            <CustomTooltip
                                arrow
                                placement="bottom"
                                title={t('actions.edit')}
                                aria-label="edit availability"
                            >
                                <CustomIconButton id="onlive-button-edit" size="small" onClick={onEdit}>
                                    <EditOutlinedIcon component="svg" />
                                </CustomIconButton>
                            </CustomTooltip>
                        ) : null}

                        {onDelete ? (
                            <CustomTooltip
                                arrow
                                placement="bottom"
                                title={t('actions.delete')}
                                aria-label="delete availability"
                            >
                                <CustomIconButton id="onlive-button-edit" size="small" onClick={handleDelete}>
                                    <DeleteOutlineOutlinedIcon component="svg" />
                                </CustomIconButton>
                            </CustomTooltip>
                        ) : null}

                        <ActionButton size="small" onClick={() => toggle(availability.id)} color="default" fitWidth>
                            {expanded === availability.id ? t('app.common.close') : t('app.common.details')}
                        </ActionButton>
                    </Stack>
                </Stack>
                {expanded === availability.id && <MyAvailabilityDetails availability={availability} />}
            </Stack>

            {openConfirmDeleteDlg && (
                <YesNoDialog
                    openDialog={true}
                    title={titleDlg}
                    messageToConfirm={messageDlg}
                    yesButtonCallback={() => {
                        confirmDelete();
                    }}
                    noButtonCallback={() => {
                        cancelDlg();
                    }}
                />
            )}
        </Fragment>
    );
};

export default MyAvailabilityCard;
